module.exports = __webpack_public_path__ + "img/vegetable-radishes-350x184.facd6e15.jpg";